import { Trans, useTranslation } from "react-i18next";
import { img } from "../../constants/assets";
import ScrollReveal from "../../components/ScrollReveal";
import ComparisonTable from "../../components/ComparisonTable";
import PlatformCapabilities from "../../components/PlatformCapabilities";
import { useBookDemo } from "../../context/BookDemoContext";

function Solutions() {
  const { t } = useTranslation();
  const { openBookDemo } = useBookDemo();
  const telecomBenefits = t("solutions.telecomBenefits", { returnObjects: true });

  return (
    <>
      <section className="solutions-hero">
        <div className="container py-2">
          <div className="row align-items-center g-4 g-lg-5 solutions-hero-row">
            <div className="col-md-6 d-flex hero-content hero-home">
              <div className="animate__animated animate__fadeInLeftBig animate__slow">
                <p className="banner-sub-heading p-2">
                  {t("solutions.heroOverline")}
                </p>
                <h1 className="solutions-hero-title">
                  <Trans
                    i18nKey="solutions.heroTitle"
                    components={{
                      1: <span className="gradient-text-span" />,
                    }}
                  />
                </h1>
                <p className="pera-cs solutions-hero-desc">
                  {t("solutions.heroDesc")}
                </p>
                <div className="btn-group gap-3">
                  <button
                    className="btn-cs btn-lang d-flex gap-2 py-3 fw-normal"
                    type="button"
                    onClick={openBookDemo}
                  >
                    {t("common.exploreDemo")}
                    <span className="img-fluid">
                      <img src={img("Border.svg")} alt="" />
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="solutions-growth-section py-50">
        <div className="container">
          <div className="row align-items-center g-4 g-lg-5">
            <div className="col-lg-5 hero-content h-auto">
              <ScrollReveal from="left" className="platform-content">
                <p className="banner-sub-heading p-2">
                  {t("solutions.growthOverline")}
                </p>
                <h2 className="solutions-growth-title">
                  <Trans
                    i18nKey="solutions.growthTitle"
                    components={{
                      1: <span className="gradient-text-span" />,
                    }}
                  />
                </h2>
                <p className="pera-cs solutions-growth-desc">
                  {t("solutions.growthDesc")}
                </p>
              </ScrollReveal>
            </div>

            <div className="col-lg-7">
              <div className="solutions-growth-collage">
                <img
                  className="solutions-growth-collage__main"
                  src={img("growthstage-one.svg")}
                  alt={t("solutions.growthImage1Alt")}
                />
                <img
                  className="solutions-growth-collage__stacked"
                  src={img("growthstage-two.svg")}
                  alt={t("solutions.growthImage2Alt")}
                />
                <img
                  className="solutions-growth-collage__stacked"
                  src={img("growthstage-three.svg")}
                  alt={t("solutions.growthImage3Alt")}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <PlatformCapabilities />

      <ComparisonTable />

      <section className="platform-section py-50">
        <div className="container">
          
          <div className="row align-items-center g-4 g-lg-5">
             <h2 className="platform-title">
                <Trans
                  i18nKey="solutions.benefitsTitle"
                  components={{
                    1: (
                      <span className="gradient-text-span--brand gradient-text-span" />
                    ),
                  }}
                />
              </h2>
            <div className="col-lg-6">
              <div className="row g-3 why-choose-cards solutions-card">
                {telecomBenefits.map((item) => (
                  <div className="col-12" key={item.title}>
                    <article className="why-choose-card d-flex gap-3 align-items-start">
                      <span className="platform-check" aria-hidden="true">
                        <img src={img("check.svg")} alt="" />
                      </span>
                      <div>
                        <h3 className="why-choose-card-title">{item.title}</h3>
                        <p className="why-choose-card-text">{item.description}</p>
                      </div>
                    </article>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="platform-media">
                <img
                  className="platform-image"
                  src={img("benifts.svg")}
                  alt={t("solutions.benefitsImageAlt")}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="working py-50 solution-working">
        <div className="container">
          <div className="row align-items-center g-4 g-lg-5">
            <div className="col-lg-5">
              <div className="platform-media">
                <img
                  className="platform-image"
                  src={img("customer-offer.svg")}
                  alt={t("solutions.benefitsImageAlt")}
                />
              </div>
            </div>
            <div className="col-lg-7 hero-content h-auto px-0 mt-0">
              <h2 className="why-choose-title mb-4">
                {t("solutions.offerTitle")}
              </h2>
              <p className="pera-cs">{t("solutions.offerDesc1")}</p>
              <p className="pera-cs">{t("solutions.offerDesc2")}</p>
              <p className="pera-cs">{t("solutions.offerDesc3")}</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Solutions;
